<script context="module" lang="ts">
	import TextWithIcon from '$lib/components/util/TextWithIcon.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Button from '$lib/components/util/Button.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Section from '$lib/components/layout/Section.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';

	export const config: SectionConfig = {
		collection: 'section_product_highlight',
		availableFor: ['pages', 'special-pages', 'posts'],
		query: gql`
	  type
      media {
				... Media
      }
      badges {
				directus_files_id {
					... Media
				}
      }
      translations {
				languages_code {
					code
				}
				title
				subtitle
				text
				price
			}
			link {
				...Link
			}
    `
	};
	type Props = {
		title: string;
		media: any;
		link: any;
		type: any;
		price: string;
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section gapType="margin" class="section-product-highlight {data.type}">
	<div class="section-background">
		<Media {...data.media} fit="cover" transform="xl" />
		<div class="wrapper">
			<div class="title">
				{data.title}
			</div>
			<div class="row">
				{#if data.price}
					<div class="row-wrapper">
						<div class="price">
							{data.price}
						</div>

						<div class="divider" />

						<DirectusLink {...data.link}>
							<Button {...data.link} />
						</DirectusLink>
					</div>
				{:else}
					<div class="product-link">
						<DirectusLink {...data.link}>
							<TextWithIcon {...data.link} />
						</DirectusLink>
					</div>
				{/if}
			</div>
		</div>
	</div>
</Section>

<style lang="scss">
	:global(.section-product-highlight .inner-section) {
		max-width: 1200px !important;
		position: relative;
		.section-background {
			position: relative;
			overflow: hidden;
			:global(img) {
				aspect-ratio: 16 / 8;
				border-radius: v(border-radius);
				@include media(phone) {
					aspect-ratio: 1 / 1;
				}
			}
		}
	}
	:global(.section-product-highlight.slim) {
		:global(.inner-section) {
			max-width: 500px !important;

			.section-background {
				:global(img) {
					aspect-ratio: 4 / 5;
				}
				@include media(phone) {
				}
			}
		}
	}

	.wrapper {
		border-image-source: url(../../assets/img/border.svg);
		border-image-width: 4px;
		border-image-slice: 2 2 fill;
		border-image-outset: 4px;
		border-image-repeat: strech;
		max-width: 800px;
		padding: v(content-padding);
		position: absolute;
		bottom: v(content-padding);
		inset-inline-start: v(content-padding);
		@include media(phone) {
			max-width: 100%;
			bottom: auto;
			top: auto;
			bottom: 4%;
			inset-inline-end: 4%;
			inset-inline-start: 4%;
		}
	}

	.title,
	.price {
		@include font(h4);
	}
	.title {
		margin-bottom: v(content-gap-xs);
	}
	.row {
		border-top: solid 1px color(black);
	}
	.row-wrapper {
		display: flex;
		gap: v(content-gap);
		align-items: center;
		padding: v(content-padding-xs) 0;

		border-bottom: solid 1px color(black);
		justify-content: space-between;
	}
	.divider {
		width: 1px;
		height: 30px;
		background: var(--color-black);
	}
	.product-link {
		padding-top: v(content-padding-xs);
	}
</style>
